/* WOW! Feestverhuur: bezorgkosten-indicatie op basis van postcode.
   Regel: bezorging EUR 20 (gratis vanaf EUR 100 bestelwaarde), kilometers EUR 1 per gereden km,
   heen en terug geteld, de eerste 10 km per richting zijn gratis (vanaf 9403 AS Assen).
   Afstand = hemelsbreed (PDOK) x wegfactor. Altijd een indicatie. */
(function () {
  var ORIGIN = '9403AS', FEE = 20, FREE_FROM = 100, FREE_KM_PER_WAY = 10, ROAD = 1.25;
  var cache = {};
  function norm(pc) { return String(pc || '').replace(/\s+/g, '').toUpperCase(); }
  function validPc(pc) { return /^[1-9][0-9]{3}[A-Z]{2}$/.test(pc); }
  function geocode(pc) {
    pc = norm(pc);
    if (cache[pc]) return cache[pc];
    var url = 'https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?q=' + encodeURIComponent(pc) + '&fq=type:postcode&rows=1&fl=centroide_ll';
    cache[pc] = fetch(url).then(function (r) { return r.json(); }).then(function (j) {
      var d = j && j.response && j.response.docs && j.response.docs[0];
      if (!d || !d.centroide_ll) throw new Error('postcode');
      var m = /POINT\(([-0-9.]+) ([-0-9.]+)\)/.exec(d.centroide_ll);
      return { lon: parseFloat(m[1]), lat: parseFloat(m[2]) };
    });
    return cache[pc];
  }
  function hav(a, b) {
    var R = 6371, rad = Math.PI / 180;
    var dLat = (b.lat - a.lat) * rad, dLon = (b.lon - a.lon) * rad;
    var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * R * Math.asin(Math.sqrt(x));
  }
  function estimate(pc, orderValue) {
    pc = norm(pc);
    if (!validPc(pc)) return Promise.reject(new Error('invalid'));
    return Promise.all([geocode(ORIGIN), geocode(pc)]).then(function (r) {
      var oneWay = Math.ceil(hav(r[0], r[1]) * ROAD);
      var paidKm = Math.max(0, oneWay * 2 - FREE_KM_PER_WAY * 2);
      var free = orderValue != null && orderValue >= FREE_FROM;
      var fee = free ? 0 : FEE;
      return { oneWay: oneWay, driven: oneWay * 2, paidKm: paidKm, kmCost: paidKm, fee: fee, free: free, total: fee + paidKm };
    });
  }
  function eur(n) { return '€ ' + Math.round(n).toLocaleString('nl-NL'); }
  window.WOWDelivery = { estimate: estimate, eur: eur, norm: norm, validPc: validPc };

  function lineHtml(label, val) { return '<div style="display:flex;justify-content:space-between;gap:16px;padding:6px 0;border-bottom:1px solid #e3e3e8"><span>' + label + '</span><strong>' + val + '</strong></div>'; }

  function initCalc(root) {
    var input = root.querySelector('[data-wow-pc]');
    var order = root.querySelector('[data-wow-order]');
    var out = root.querySelector('[data-wow-out]');
    var btn = root.querySelector('[data-wow-go]');
    var stored = ''; try { stored = sessionStorage.getItem('wow_postcode') || ''; } catch (e) {}
    if (stored && input && !input.value) input.value = stored;
    function run() {
      var pc = WOWDelivery.norm(input.value);
      if (!WOWDelivery.validPc(pc)) { out.innerHTML = '<p style="margin:0;color:#b3261e;font-weight:700">Vul een geldige postcode in, bijvoorbeeld 9403 AS.</p>'; return; }
      out.innerHTML = '<p style="margin:0">Even rekenen...</p>';
      var ov = order && order.value !== '' ? parseFloat(String(order.value).replace(',', '.')) : (root.dataset.order ? parseFloat(root.dataset.order) : null);
      WOWDelivery.estimate(pc, isNaN(ov) ? null : ov).then(function (e) {
        try { sessionStorage.setItem('wow_postcode', input.value); } catch (x) {}
        var h = lineHtml('Afstand vanaf Assen (enkele reis)', 'ca. ' + e.oneWay + ' km');
        h += lineHtml('Bezorging' + (e.free ? ' (gratis vanaf € 100)' : ''), e.free ? '€ 0' : WOWDelivery.eur(e.fee));
        h += lineHtml('Kilometers: ' + e.driven + ' km heen en terug, eerste 10 km per richting gratis', WOWDelivery.eur(e.kmCost));
        h += '<div style="display:flex;justify-content:space-between;gap:16px;padding:12px 0 0;font-size:1.9rem"><strong>Indicatie bezorging</strong><strong style="color:#d6247f">' + WOWDelivery.eur(e.total) + '</strong></div>';
        h += '<p style="margin:10px 0 0;font-size:1.4rem;color:#5a5a63">Indicatie op basis van je postcode. Het definitieve bedrag bevestigen wij bij je boeking.</p>';
        out.innerHTML = h;
      }).catch(function () { out.innerHTML = '<p style="margin:0;color:#b3261e;font-weight:700">We konden deze postcode niet vinden. Controleer de postcode of bel ons: 06-17643861.</p>'; });
    }
    if (btn) btn.addEventListener('click', run);
    if (input) input.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); run(); } });
    if (stored && validPc(norm(stored)) && root.hasAttribute('data-wow-auto')) run();
  }

  function initSearchForm(f) {
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var d = f.querySelector('[name=date]'), p = f.querySelector('[name=postcode]');
      try { if (d && d.value) sessionStorage.setItem('wow_date', d.value); if (p && p.value) sessionStorage.setItem('wow_postcode', p.value); } catch (e) {}
      window.location.href = f.getAttribute('data-target') || '/collections/alle-springkussens';
    });
  }

  function initSummary(el) {
    var d = '', p = '';
    try { d = sessionStorage.getItem('wow_date') || ''; p = sessionStorage.getItem('wow_postcode') || ''; } catch (e) {}
    if (!d && !p) return;
    var txt = [];
    if (d) { var dt = new Date(d + 'T12:00:00'); txt.push('datum <strong>' + dt.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long' }) + '</strong>'); }
    var ph = txt.length ? 'Je zoekt voor ' + txt.join(' en ') + '. ' : '';
    el.hidden = false;
    var slot = el.querySelector('[data-wow-sum]');
    slot.innerHTML = ph + (d ? 'Kies hieronder in de kalender je datum om te zien wat beschikbaar is.' : '');
    var out = el.querySelector('[data-wow-sum-del]');
    if (p && WOWDelivery.validPc(WOWDelivery.norm(p))) {
      WOWDelivery.estimate(p, null).then(function (e) {
        out.innerHTML = 'Bezorging naar <strong>' + p + '</strong>: indicatie <strong>' + WOWDelivery.eur(e.total) + '</strong> (gratis bezorgfee vanaf € 100 bestelwaarde).';
      }).catch(function () {});
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-wow-calc]').forEach(initCalc);
    document.querySelectorAll('[data-wow-search]').forEach(initSearchForm);
    document.querySelectorAll('[data-wow-summary]').forEach(initSummary);
  });
})();
